import type { ReactNode } from 'react';

import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';

interface NebariTopBarProps {
  /** Centred. Omitted where the mode has no search. */
  search?: ReactNode;
  /** Right-aligned controls, such as the mode switch. */
  actions?: ReactNode;
}

/** The tablet and desktop top bar. Sections, the brand mark and the account
 *  menu all live in the left panel. Hidden at mobile, where `NebariMobileBar`
 *  takes its place. */
export default function NebariTopBar({ search, actions }: NebariTopBarProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <div
      data-testid="nav-top-bar"
      className="hidden h-14 shrink-0 items-center px-4 navtab:flex"
      style={{ background: t.bg, borderBottom: `1px solid ${t.border}` }}
    >
      {/* Balances the actions so search stays centred whether or not there are
          any, and keeps the actions right-aligned when there is no search. */}
      <div className="flex-1" />
      {search}
      <div className="flex flex-1 justify-end">{actions}</div>
    </div>
  );
}
